// src/components/AutocompleteTagFilter.jsx
import React from "react";
import TagCombobox from "./TagCombobox";

// Tag picker used to filter the order list: selection only, no tag creation.
const AutocompleteTagFilter = ({ selectedTags, setSelectedTags }) => (
  <TagCombobox
    selectedTags={selectedTags}
    setSelectedTags={setSelectedTags}
    placeholder="חפש תג…"
    triggerLabel="סינון לפי תג…"
    triggerAriaLabel="סינון לפי תגיות"
  />
);

export default AutocompleteTagFilter;
